import type { UserInputValidationError } from '@tectonics/prs/validation';

export function validateNigerianEWallet(
  selectedPaymentMethod: string,
  selectedEwallet: string
): UserInputValidationError | undefined {
  if (selectedPaymentMethod !== 'ewallet') {
    return undefined;
  }

  return !selectedEwallet || selectedEwallet.trim() === '' ? { id: 'empty' } : undefined;
}
